import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (password.length < 8) return toast.error("Password must be at least 8 characters.");
    if (password !== confirm) return toast.error("Passwords do not match.");
    setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      toast.success("Password updated. You can sign in now.");
      navigate("/welcome");
    } catch (e) { toast.error(e.response?.data?.detail || "That reset link is invalid or expired."); }
    finally { setBusy(false); }
  };

  return <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "#FFF9F0" }}>
    <div className="open-book max-w-md w-full p-8">
      <KeyRound className="w-12 h-12 mx-auto mb-4" style={{ color: "#0284C7" }} />
      <h1 className="font-heading text-2xl font-bold text-center" style={{ color: "#4A3224" }}>Choose a new password</h1>
      <p className="text-center text-sm mt-2 mb-6" style={{ color: "#7A5946" }}>Use at least 8 characters.</p>
      <div className="space-y-3">
        <input className="w-full rounded-xl border p-3" type="password" placeholder="New password" value={password} onChange={e => setPassword(e.target.value)} />
        <input className="w-full rounded-xl border p-3" type="password" placeholder="Confirm password" value={confirm} onChange={e => setConfirm(e.target.value)} />
        <button onClick={submit} disabled={busy || !token} className="tt-btn tt-btn-ocean w-full py-3 disabled:opacity-40">{busy ? "Saving..." : "Reset Password"}</button>
      </div>
    </div>
  </div>;
}
